export default function CursorPosition() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                scope.$watch(attrs.cursorPosition, function() {
                    const valueLength = element[0].value.length;

                    /**
                     * Change cursor position to the end of string
                     */
                    setTimeout(function() {
                        element[0].focus();
                        element[0].setSelectionRange(valueLength, valueLength);
                    }, 50);
                });
            },
        };
}



// WEBPACK FOOTER //
// ./src/app/directives/cursorPosition.directive.js